// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1791544784162
      var cssReload = require("/home/tuco/t2s/web/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  